import React from "react";
import { Link } from "react-router-dom";

/**
 * PageHeader component represents the header section of a page.
 * It includes the page heading, optional back button, and additional content.
 *
 * @component
 * @param {Object} props - Props for the component.
 * @param {ReactNode} props.children - Additional content to be included in the header.
 * @param {string} props.heading - The main heading of the page.
 * @param {boolean} props.backButton - Flag to determine if a back button should be displayed.
 * @param {string} props.backPath - The path to navigate when the back button is clicked.
 * @returns {JSX.Element} JSX.Element representing the PageHeader component.
 */
function PageHeader({ children, heading, backButton = false, backPath = "#" }) {
  return (
    <>
      <div className="nk-block-head-content">
        { backButton && 
          <div className="nk-block-head-sub">
            <Link className="back-to" to={backPath}><em className="icon ni ni-arrow-left"/><span>Back</span></Link>
          </div>
        }
        <h3 className="nk-block-title page-title">{heading}</h3>
        <div className="nk-block-des">
          {children}
        </div>
      </div>
    </>
  );
}

export default PageHeader;
